/** Live Tracking reads `?follow=` on load and follows that vehicle. */
export const FOLLOW_PARAM = "follow";

export function trackingFollowHref(vehicleId: string): string {
  return `/tracking?${FOLLOW_PARAM}=${encodeURIComponent(vehicleId)}`;
}
